module.exports = __webpack_public_path__ + "static/img/task1.c323b3bb.png";